



const SelectLanguage = ({select}) => {
    return (
        <select defaultValue={select}>
            <option value="all">All Language</option>
            <option value="english">English</option>
            <option value="hindi">Hindi</option>
            <option value="telugu">Telugu</option>
            <option value="tamil">Tamil</option>
            <option value="kannada">Kannada</option>

        </select>
    );
}
 
export default SelectLanguage;